/**
 * .
 * Created by jlado on 13/9/16.
 */
export class MailReceiverType {

    id: string;
    description: string;

    constructor(other ?: MailReceiverType) {
        if (other) {
            this.id = other.id;
            this.description = other.description;
        }
    }

    toString() {
        return this.description;
    }
}

/*Necesario para el selector multiple*/
export class MailReceiverTypeOption {

    id: string;
    text: string;

    constructor(other ?: MailReceiverType) {
        if (other) {
            this.id = other.id;
            this.text = other.description;
        }
    }

    toString() {
        return this.text;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/mailReceiverType.ts
 **/